import { deepMerge } from '../util/data';
import type { Token } from '../core/token';
import defaultsTokenBuilder from './defaultsToken';
import presetLightBuilder from './preset/light';
import presetDarkBuilder from './preset/dark';

const presetBuilderMap = {
  light: presetLightBuilder,
  dark: presetDarkBuilder
} as const;

export function presetThemeBuilder(preset: keyof typeof presetBuilderMap, overrideToken?: Token) {
  const presetTokens = presetBuilderMap[preset]?.() || {};

  return defaultsTokenBuilder(deepMerge(presetTokens, overrideToken, { override: true }) as Token);
}
